module.exports = __webpack_public_path__ + "media/country_flags/ma-eaf2804a.png";